import React from 'react';
import { COLOR_VARIANTS, Checkbox, TYPOGRAPHY_VARIANT, Typography } from '@tajawal/ct-web-design-system';
import { SelectFilter } from '@tajawal/web-flights-sdk/lib/types/filters/select-filter.types';
import { AIRPORT_FILTER_TYPES } from '@/constants/common.constants';
import ArrowElbowDownRight from '@/assets/images/ArrowElbowDownRight.svg';
import { buildTestId } from '@/utils/helpers.utils';
import { useTranslation } from 'react-i18next';
import Styled from './OptionsGroup.styled';
import _map from 'lodash/map';
import Image from '@/app-common/components/Image';

type OptionsGroupProps = {
  testId: string;
  title: string;
  cityName: string;
  airports: Record<string, SelectFilter[]>;
  type: string;
  onSelect: (params: { type: string; code: string; selected: boolean }) => void;
};

const OptionsGroup = ({ testId, title, cityName, airports, type, onSelect }: OptionsGroupProps) => {
  const { t } = useTranslation();

  const renderAirportFilter = (state, filterType, addMargin) => {
    return _map(state, ({ code, selected, label }) => (
      <div style={{ marginBottom: addMargin ? 8 : 0 }}>
        <Checkbox
          isSingle
          testId={buildTestId(testId, `${filterType}_Option_${code}`)}
          key={code}
          onChange={() => onSelect({ type: filterType, code, selected })}
          isChecked={selected}
          label={label}
          helperText={code}
        />
      </div>
    ));
  };

  const renderOthersAirports = (state, filterType, sectionTitle) => (
    <div style={{ width: '100%' }}>
      <Styled.OtherAirportTitle>
        <Image src={ArrowElbowDownRight} alt={sectionTitle} />
        <Typography variant={TYPOGRAPHY_VARIANT.BODY2} component="p" color={COLOR_VARIANTS.GREYCHATEAU}>
          {sectionTitle}
        </Typography>
      </Styled.OtherAirportTitle>
      <Styled.OtherAirportState>{renderAirportFilter(state, filterType, true)}</Styled.OtherAirportState>
    </div>
  );

  return (
    <>
      <Typography variant={TYPOGRAPHY_VARIANT.HEADING4SEMBLD} component="h4">
        {title} {cityName}
      </Typography>
      <Styled.StateWrapper>
        {renderAirportFilter(airports[AIRPORT_FILTER_TYPES.AIRPORT], type, false)}
        {!!airports[AIRPORT_FILTER_TYPES.NEAR_BY] &&
          renderOthersAirports(airports[AIRPORT_FILTER_TYPES.NEAR_BY], type, t('Filters.NearBy'))}
        {!!airports[AIRPORT_FILTER_TYPES.OTHERS] &&
          renderOthersAirports(airports[AIRPORT_FILTER_TYPES.OTHERS], type, t('Filters.Other_Options'))}
      </Styled.StateWrapper>
    </>
  );
};

export default OptionsGroup;
